import React from 'react'
import MaterialSymbol from '../material-symbol'

const Delete = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="delete" {...props} />
))

Delete.displayName = 'Delete'

export default Delete
